// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input__container-c97754 {
  --text-field-input-border-color: --brand-secondary-40;
  --text-field-input-border-width: 0;
  --text-field-label-color: var(--base-80);
  --text-field-message-color: var(--base-80);
  --text-field-input-color: var(--base-110);
  --text-field-placeholder-color: var(--base-80);
  --text-field-background-color: var(--base-20);
  --text-field-transition-duration: 0.2s;
}

.Input__content-a216bf {
  position: relative;
  background-color: var(--text-field-background-color);
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  cursor: text;
}

.Input__input-wrapper-c6a5a4 {
  height: 100%;
  box-sizing: border-box;
  padding: 14px 12px;
  display: flex;
  flex-direction: column;
}

.Input__withPrefix-d5632a .Input__input-wrapper-c6a5a4 {
  flex-direction: row;
  gap: 4px;
}

.Input__with-label-e41413 .Input__input-wrapper-c6a5a4 {
  padding-top: 22px;
  padding-bottom: 6px;
}

.Input__content-a216bf::after {
  content: "";
  height: var(--text-field-input-border-width);
  width: 100%;
  position: absolute;
  bottom: 0;
  inset-inline-start: 0;
  background-color: var(--text-field-input-border-color);
  transition-duration: var(--text-field-transition-duration);
  transition-timing-function: ease;
  transition-property: height;
}

.Input__focused-fbb31b,
.Input__success-ac20d9,
.Input__hasError-fe1004 {
  --text-field-input-border-width: 2px;
}

.Input__focused-fbb31b {
  --text-field-input-border-color: var(--brand-secondary-40);
}

.Input__success-ac20d9 {
  --text-field-input-border-color: var(--success-30);
  --text-field-label-color: var(--success-30);
  --text-field-message-color: var(--success-30);
}

.Input__hasError-fe1004 {
  --text-field-input-border-color: var(--danger-40);
  --text-field-label-color: var(--danger-40);
  --text-field-message-color: var(--danger-40);
}

.Input__disabled-b4404d {
  cursor: default;
  --text-field-label-color: var(--base-50);
  --text-field-input-color: var(--base-50);
}

.Input__label-be2497 {
  position: absolute;
  display: block;
  top: 0;
  inset-inline-start: 0;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--text-field-label-color);
  z-index: 1;
  transform: translate(12px, 14px) scale(1);
  transform-origin: top left;
  pointer-events: none;
  transition-duration: var(--text-field-transition-duration);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-property: color, transform;
  max-width: 100%;
  white-space: nowrap;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
}

:root[dir=rtl] .Input__label-be2497 {
  transform: translate(-12px, 14px) scale(1);
}

.Input__small-label-a98565 .Input__label-be2497,
.Input__container-c97754:has(.Input__input-c14114:is(:-webkit-autofill, :autofill)) .Input__label-be2497 {
  transform: translate(12px, 5px) scale(0.75);
}

:root[dir=rtl] .Input__small-label-a98565 .Input__label-be2497,
:root[dir=rtl] .Input__container-c97754:has(.Input__input-c14114:is(:-webkit-autofill, :autofill)) .Input__label-be2497 {
  transform: translate(12px, 5px) scale(0.75);
}

.Input__prefix-d6d72d,
.Input__input-c14114 {
  color: var(--text-field-input-color);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  height: 100%;
}

.Input__input-c14114 {
  display: block;
  padding: 0;
  box-sizing: border-box;
  flex: 1;
}

.Input__input-c14114::placeholder {
  color: var(--text-field-placeholder-color);
}

/*
  Workaround to hide autofilled input background
  background: none !important doesn't work
*/
.Input__input-c14114:autofill,
.Input__input-c14114:autofill:focus,
.Input__input-c14114:autofill:hover {
  box-shadow: 0 0 0px 1000px var(--text-field-background-color) inset;
  -webkit-text-fill-color: var(--text-field-input-color);
  color: var(--text-field-input-color);
}

.Input__message-ff16b5 {
  min-height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--text-field-message-color);
  padding: 4px 12px 0px 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/hooks/useInputClassNames/Input/Input.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qDAAA;EACA,kCAAA;EACA,wCAAA;EACA,0CAAA;EACA,yCAAA;EACA,8CAAA;EACA,6CAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,4CAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,sDAAA;EACA,0DAAA;EACA,gCAAA;EACA,2BAAA;AACF;;AAEA;;;EAGE,oCAAA;AACF;;AAEA;EACE,0DAAA;AACF;;AAEA;EACE,kDAAA;EACA,2CAAA;EACA,6CAAA;AACF;;AAEA;EACE,iDAAA;EACA,0CAAA;EACA,4CAAA;AACF;;AAEA;EACE,eAAA;EACA,wCAAA;EACA,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,oCAAA;EACA,UAAA;EACA,yCAAA;EACA,0BAAA;EACA,oBAAA;EACA,0DAAA;EACA,sDAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;;EAEE,2CAAA;AACF;;AAEA;;EAEE,2CAAA;AACF;;AAEA;;EAEE,oCAAA;EACA,wBAAA;EACA,0CAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,sBAAA;EACA,OAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;;;CAAA;AAIA;;;EAGE,mEAAA;EACA,sDAAA;EACA,oCAAA;AACF;;AAEA;EACE,gBAAA;EACA,2BAAA;EACA,6CAAA;EACA,sCAAA;EACA,0BAAA;AACF","sourcesContent":[".container {\n  --text-field-input-border-color: --brand-secondary-40;\n  --text-field-input-border-width: 0;\n  --text-field-label-color: var(--base-80);\n  --text-field-message-color: var(--base-80);\n  --text-field-input-color: var(--base-110);\n  --text-field-placeholder-color: var(--base-80);\n  --text-field-background-color: var(--base-20);\n  --text-field-transition-duration: 0.2s;\n}\n\n.content {\n  position: relative;\n  background-color: var(--text-field-background-color);\n  border-radius: 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  cursor: text;\n}\n\n.input-wrapper {\n  height: 100%;\n  box-sizing: border-box;\n  padding: 14px 12px;\n  display: flex;\n  flex-direction: column;\n}\n\n.withPrefix .input-wrapper {\n  flex-direction: row;\n  gap: 4px;\n}\n\n.with-label .input-wrapper {\n  padding-top: 22px;\n  padding-bottom: 6px;\n}\n\n.content::after {\n  content: '';\n  height: var(--text-field-input-border-width);\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  inset-inline-start: 0;\n  background-color: var(--text-field-input-border-color);\n  transition-duration: var(--text-field-transition-duration);\n  transition-timing-function: ease;\n  transition-property: height;\n}\n\n.focused,\n.success,\n.hasError {\n  --text-field-input-border-width: 2px;\n}\n\n.focused {\n  --text-field-input-border-color: var(--brand-secondary-40);\n}\n\n.success {\n  --text-field-input-border-color: var(--success-30);\n  --text-field-label-color: var(--success-30);\n  --text-field-message-color: var(--success-30);\n}\n\n.hasError {\n  --text-field-input-border-color: var(--danger-40);\n  --text-field-label-color: var(--danger-40);\n  --text-field-message-color: var(--danger-40);\n}\n\n.disabled {\n  cursor: default;\n  --text-field-label-color: var(--base-50);\n  --text-field-input-color: var(--base-50);\n}\n\n.label {\n  position: absolute;\n  display: block;\n  top: 0;\n  inset-inline-start: 0;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--text-field-label-color);\n  z-index: 1;\n  transform: translate(12px, 14px) scale(1);\n  transform-origin: top left;\n  pointer-events: none;\n  transition-duration: var(--text-field-transition-duration);\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  transition-property: color, transform;\n  max-width: 100%;\n  white-space: nowrap;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n:root[dir='rtl'] .label {\n  transform: translate(-12px, 14px) scale(1);\n}\n\n.small-label .label,\n.container:has(.input:is(:-webkit-autofill, :autofill)) .label {\n  transform: translate(12px, 5px) scale(0.75);\n}\n\n:root[dir='rtl'] .small-label .label,\n:root[dir='rtl'] .container:has(.input:is(:-webkit-autofill, :autofill)) .label {\n  transform: translate(12px, 5px) scale(0.75);\n}\n\n.prefix,\n.input {\n  color: var(--text-field-input-color);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  height: 100%;\n}\n\n.input {\n  display: block;\n  padding: 0;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.input::placeholder {\n  color: var(--text-field-placeholder-color);\n}\n\n/*\n  Workaround to hide autofilled input background\n  background: none !important doesn't work\n*/\n.input:autofill,\n.input:autofill:focus,\n.input:autofill:hover {\n  box-shadow: 0 0 0px 1000px var(--text-field-background-color) inset;\n  -webkit-text-fill-color: var(--text-field-input-color);\n  color: var(--text-field-input-color);\n}\n\n.message {\n  min-height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--text-field-message-color);\n  padding: 4px 12px 0px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Input__container-c97754`,
	"content": `Input__content-a216bf`,
	"input-wrapper": `Input__input-wrapper-c6a5a4`,
	"inputWrapper": `Input__input-wrapper-c6a5a4`,
	"withPrefix": `Input__withPrefix-d5632a`,
	"with-label": `Input__with-label-e41413`,
	"withLabel": `Input__with-label-e41413`,
	"focused": `Input__focused-fbb31b`,
	"success": `Input__success-ac20d9`,
	"hasError": `Input__hasError-fe1004`,
	"disabled": `Input__disabled-b4404d`,
	"label": `Input__label-be2497`,
	"small-label": `Input__small-label-a98565`,
	"smallLabel": `Input__small-label-a98565`,
	"input": `Input__input-c14114`,
	"prefix": `Input__prefix-d6d72d`,
	"message": `Input__message-ff16b5`
};
module.exports = ___CSS_LOADER_EXPORT___;
